exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table[data-v-3c9efb77]{border-collapse:collapse;width:100%}td[data-v-3c9efb77],th[data-v-3c9efb77]{border:1px solid #ddd;text-align:left;padding:8px}tr[data-v-3c9efb77]:nth-child(2n){background-color:#eaeaea}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3c9efb77","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/elements/display.vue
// module id = 169
// module chunks = 0